import {useMemo} from 'react';
import {assert} from 'assert-ts';
import type {Schema} from 'schemaDefinition/types';
import type {ThesaurusesMap} from 'services/thesaurus/types';
import {selectThesaurus} from 'services/thesaurus/thesaurusSlice';
import {useAppSelector} from 'store/hooks';
import {useSchemaThesaurusIds} from './useSchemaThesaurusIds';

/**
 * Assumes needed thesauruses have been loaded
 * @param schema
 * @returns
 */
export const useSchemaThesauruses = (
  schema: Schema | undefined,
): ThesaurusesMap => {
  const thesaurusIds = useSchemaThesaurusIds(schema);
  const thesauruses = useAppSelector(selectThesaurus);

  return useMemo(() => {
    return thesaurusIds.reduce<ThesaurusesMap>((acc, id) => {
      const thesaurus = assert(
        thesauruses[id],
        `useSchemaThesauruses: missing thesaurus for id: ${id}`,
        {id},
      );
      assert(
        thesaurus.status === 'Loaded',
        'useSchemaThesauruses: thesaurus not loaded',
        {id},
      );
      acc[id] = thesaurus.data;
      return acc;
    }, {} as ThesaurusesMap);
  }, [thesaurusIds, thesauruses]);
};
